<template>
	<PublicMenuLayoutV2 showInstallAppButton>
		<template v-slot:nav-btn-items>
			<b-nav-item class="my-auto d-none d-desktop-block d-xl-block ml-0 ml-xl-2">
				<router-link to="/inicio-sesion">
					<ArrowButton :text="$t('login-wrd')" :action="() => { $router.push('/inicio-sesion') }" reverse :backgroundColor="BLUE_COLOUR" :textColor="WHITE_COLOUR"/>
				</router-link>
			</b-nav-item>
		</template>
	</PublicMenuLayoutV2>
</template>

<script>
	import PublicMenuLayoutV2 from '@/components/layouts/PublicMenuLayoutV2'
	import ArrowButton from '@/components/base/buttons/ArrowButton'
	import { BNavItem } from 'bootstrap-vue'
	import { BLUE_COLOUR, WHITE_COLOUR } from '@/constants/colours'
	import gtagMixin from '@/mixins/gtag.mixin'

	export default {
		name: 'Opensalud360Layout',
		mixins: [gtagMixin],
		components: {
			BNavItem,
			PublicMenuLayoutV2,
			ArrowButton
		},
		data () {
			return {
				BLUE_COLOUR,
				WHITE_COLOUR
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/layouts/Opensalud360Layout.vue